import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import { partialDateToValue } from 'neuro-utils';
import colors from '../../../../config/theme/colors';

import type { IFieldItem } from '../../utils/index';
import { mergeDocuments, parseValue } from '../../utils/index';
import { surveyCreator, surveyEditor } from 'Routes/MyService/util/index';
import { formatPartialDate } from 'Utility/date';
import { useAppSelector } from 'Store/index';

// Function for combining the value and the date into an element
const ValueDateItem = ({ value, date }: IValueDateItemProps): React.JSX.Element => (
  <>
    <div>{value ?? '-'}</div>
    <div style={{ fontSize: '1.2rem', color: colors.darkGray }}>{date ? formatPartialDate(date) : ''}</div>
  </>
);

interface IValueDateItemProps {
  value: React.JSX.Element | number | string | undefined;
  date?: PartialDate | undefined;
}

// Maps through all fields and turns them into valuedateitems
const Content = ({ array }: IContentProps): React.JSX.Element => (
  <>
    {array.map(
      (item: IFieldItem) =>
        !item.hide && (
          <React.Fragment key={item.name + item.id}>
            <HistoryRowVerticalItem
              header={<FormattedMessage id={`lifestyle.${item.name}.title`} />}
              value={<ValueDateItem value={parseValue(item)} date={item.date} />}
            />
          </React.Fragment>
        ),
    )}
  </>
);

interface IContentProps {
  array: Array<IFieldItem>;
}

const LifestyleHistoryRowData = ({ d, docs }: IOwnProps): React.JSX.Element => {
  const documents = docs.filter(n => (partialDateToValue(n.date) || 0) <= (partialDateToValue(d.date) || 0));
  const document = mergeDocuments('history', documents);

  const mysqUserId = useAppSelector(s => s.myapp.mysqUserId);
  const users = useAppSelector(s => s.session.orgUsers) ?? [];
  const { delegates = [], informants = [] } = useAppSelector(s => s.patient);

  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  return (
    <>
      <HistoryRowVerticalItem
        header={fm('myService.reporter')}
        value={
          <span style={{ fontWeight: 600 }}>{surveyCreator(d, mysqUserId, users, delegates, informants, fm)}</span>
        }
      />
      {surveyEditor(d, mysqUserId, users, delegates, informants, fm) && (
        <HistoryRowVerticalItem
          header={fm('myService.edited')}
          value={
            <span style={{ fontWeight: 600 }}>{surveyEditor(d, mysqUserId, users, delegates, informants, fm)}</span>
          }
        />
      )}
      {<Content array={document} />}
    </>
  );
};

interface IOwnProps {
  d: IDocumentWithTypeV2<'lifestyle' | 'parkinsonLifestyle'>;
  docs: IDocumentWithTypeV2<'lifestyle' | 'parkinsonLifestyle'>[];
  startEdit: StartEdit;
}

export default LifestyleHistoryRowData;
